import { render, staticRenderFns } from "./baseUpload.vue?vue&type=template&id=263554b6&scoped=true&"
import script from "./baseUpload.vue?vue&type=script&lang=js&"
export * from "./baseUpload.vue?vue&type=script&lang=js&"
import style0 from "./baseUpload.vue?vue&type=style&index=0&id=263554b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263554b6",
  null
  
)

export default component.exports